<script setup lang="ts">
    import { ref } from 'vue';
    import { useSearchContext } from '../composables/searchContext';
    import type { ProductFacet } from '../models/FacetModels';
    import { parseFacetSelection } from '../utils/facetUtils';
    const props = defineProps<{ facet: ProductFacet }>();
    const search = useSearchContext();
    const expanded = ref(props.facet.IsCurrent === 'Y');
    function selected(valueSk: number): boolean { return parseFacetSelection(search.state.facetSelected).get(props.facet.AttributeTypeSk)?.has(valueSk) ?? false; }
</script>

<template>
    <section class="facet facet-home" :id="`FacetGroup${facet.AttributeTypeSk}`">
        <button type="button" class="facet-headerbody" :aria-expanded="expanded" @click="expanded = !expanded">
            <span class="fa-solid" :class="expanded ? 'fa-chevron-down' : 'fa-chevron-right'"></span>
            <span class="facet-header" :title="facet.AttributeType">{{ facet.AttributeType }}</span><span class="facet-title">({{ facet.FacetProductCount }})</span>
        </button>
        <div v-show="expanded" class="facet-body facet-open">
            <label v-for="value in facet.Facet" :key="value.AttributeTypeValueSk" class="facet-child" :class="{ 'facet-child-active': selected(value.AttributeTypeValueSk) }">
                <input class="float-start mrgn-top5 facet-childcls" type="checkbox" :checked="selected(value.AttributeTypeValueSk)" @change="search.selectFacet(facet.AttributeTypeSk, value.AttributeTypeValueSk)" />
                <span class="facet-childname" :title="value.AttributeTypeValue">{{ value.AttributeTypeValue }}</span><span class="facet-childbody">({{ value.ProductCount }})</span>
            </label>
        </div>
    </section>
</template>
